import * as types from '../mutation-types'
import userService from '../../services/users'

const state = {
    loading: false,
    errors: '',
    oemployees: [],
}

const actions = {
    getAll({ commit }) {
        commit(types.OEMPLOYEE_LOADING, true)
        userService.getAll({ utype: "oemps" }).then(
            response => {

                commit(types.LOAD_OEMPLOYEES, response.data)
                commit(types.OEMPLOYEE_LOADING, false)
                commit(types.OEMPLOYEE_FAILURE, null)
            },
            error => {
                commit(types.OEMPLOYEE_FAILURE, error)
                commit(types.OEMPLOYEE_LOADING, false)
            }
        )
    },
    add({ commit }, data) {

        commit(types.OEMPLOYEE_LOADING, true)
        commit(types.OEMPLOYEE_FAILURE, null)
        userService.add(data).then(
            response => {

                data.id = response.data.id
                data.roles = response.data.roles;
                //console.log(data)
                commit(types.ADD_OEMPLOYEE, data)
                commit(types.OEMPLOYEE_LOADING, false)

            },
            error => {
                commit(types.OEMPLOYEE_FAILURE, error)
                commit(types.OEMPLOYEE_LOADING, false)
            }
        )
    },
    update({ commit }, data) {
        commit(types.OEMPLOYEE_LOADING, true)
        commit(types.OEMPLOYEE_FAILURE, null)
        userService.update(data.employee)
            .then(
                response => {
                    data.employee.roles = response.data.roles
                    commit(types.UPDATE_OEMPLOYEE, data)

                    commit(types.OEMPLOYEE_LOADING, false)

                },
                error => {
                    commit(types.OEMPLOYEE_FAILURE, error)
                    commit(types.OEMPLOYEE_LOADING, false)
                }
            )


    },
    delete({ commit }, data) {
        commit(types.OEMPLOYEE_LOADING, true)
        commit(types.OEMPLOYEE_FAILURE, null)
        userService.delete(data.employee.id)
            .then(
                response => {

                    commit(types.DELETE_OEMPLOYEE, data)

                    commit(types.OEMPLOYEE_LOADING, false)

                },
                error => {
                    commit(types.OEMPLOYEE_FAILURE, error)
                    commit(types.OEMPLOYEE_LOADING, false)
                }
            )
    }
}

const mutations = {
    [types.ADD_OEMPLOYEE](state, payload) {
        state.oemployees.unshift(payload);
    },
    [types.LOAD_OEMPLOYEES](state, payload) {
        state.oemployees = payload
    },
    [types.UPDATE_OEMPLOYEE](state, payload) {
        Object.assign(state.oemployees[payload.index], payload.employee);
    },
    [types.DELETE_OEMPLOYEE](state, payload) {
        state.oemployees.splice(payload.index, 1)
    },
    [types.OEMPLOYEE_FAILURE](state, payload) {
        state.errors = payload
    },

    [types.OEMPLOYEE_LOADING](state, payload) {
        state.loading = payload
    },
}


const getters = {
    OEMPLOYEES: state => {
        return state.oemployees
    },

    OEMPLOYEE_ERROR: state => {
        return state.errors
    },

    OEMPLOYEE_LOADING: state => {
        return state.loading
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/oemployees.js